import { createActions } from "reduxsauce";

export default createActions(
  {
    startUiBlockingProcess: ["processId"],
    endUiBlockingProcess: ["processId"]
  },
  { prefix: "common/" }
);



// WEBPACK FOOTER //
// ./src/modules/common/common-actions.js